import { render, staticRenderFns } from "./Advisor.vue?vue&type=template&id=15da5bda&scoped=true"
import script from "./Advisor.vue?vue&type=script&lang=js"
export * from "./Advisor.vue?vue&type=script&lang=js"
import style0 from "./Advisor.vue?vue&type=style&index=0&id=15da5bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da5bda",
  null
  
)

export default component.exports